var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDecor(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 152,
    height: 217,
    viewBox: "0 0 152 217",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0 199.26L76.5255 210L0 207.362V199.26ZM0 170.991L78.9025 196.56L0 179.877V170.991ZM0 139.411L83.5959 183.724L0 150.111V139.411ZM0 101.465L90.4408 171.904L0 115.644V101.465ZM0 51.5639L99.2482 161.443L0 72.4757V51.5639ZM14.055 0L109.753 152.668L0 12.8212V0H14.055ZM62.5217 0L121.62 145.842L43.7142 0H62.5217ZM104.422 0L134.494 141.177L88.3988 0H104.422ZM143.178 0L148 138.804L128.37 0H143.178Z",
    fill: "#FBB988"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDecor);
export default __webpack_public_path__ + "static/media/decor.d72d049b029177a6be0a621ffb4c88cb.svg";
export { ForwardRef as ReactComponent };